document.addEventListener("DOMContentLoaded", () => {
  const createLogoSwiper = (selector, reverse = false) => {
    return new Swiper(selector, {
      spaceBetween: 20,
      grabCursor: true,
      a11y: false,
      freeMode: true,
      speed: 11000,
      loop: true,
      centeredSlides: true,
      slidesPerView: 8,
      autoplay: {
        delay: 0,
        enabled: true,
        disableOnInteraction: false,
        reverseDirection: reverse, 
      },
    });
  };
  createLogoSwiper('.logo-row1', false);
  createLogoSwiper('.logo-row2', true);
});

document.addEventListener("DOMContentLoaded", function() {
  var galleryThumbs = new Swiper('.why-thumbs', {
    direction: 'vertical',
    spaceBetween: 24,
    slidesPerView: 4,
    freeMode: true,
    centeredSlides: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    autoHeight: false,
  });
  var galleryTop = new Swiper('.why-media-top', {
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 6000,      
      disableOnInteraction: false, 
  },
    thumbs: {
      swiper: galleryThumbs
    },
    on: {
      autoplayTimeLeft(s, time, progress) {
        document.querySelector('.why-thumbs').style.setProperty('--progress', 1 - progress);
      }
    }
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.checkbox input[name="pagetype"]');

  function setActiveTab(selectedInput) {
    tabs.forEach((input) => {
      const label = document.querySelector(`label[for="${input.id}"]`);
      if (input === selectedInput) label.classList.add('active');
      else label.classList.remove('active');
    });
  }

  function renderSwiperProducts(products) {
    const minItems = 16;
    let finalProducts = [...products];

    if (products.length > 0) {
      while (finalProducts.length < minItems) {
        finalProducts.push(...products);
      }
    }
    finalProducts = finalProducts.slice(0, minItems);

    const row1Wrapper = document.getElementById('row1-wrapper');
    row1Wrapper.innerHTML = '';

    finalProducts.forEach((product, index) => {
      const col = document.createElement('div');
      col.className = 'swiper-slide ecombe-template-item-wrp group ';
      col.innerHTML = `
        <div class="relative h-full  ">
          <a href="/pages/templates/${product.handle}" class="transition-all duration-300">
          <div class="relative w-full flex flex-row gap-2 transition-all overflow-hidden rounded-xl bg-white/20 border-white/30 h-full min-w-[230px] md:min-w-[360px] aspect-square border border-transparent group-hover:border-[#00F0A0]" style="max-height: 480px;">
            ${
              product.featured_images[0]
                ? `<img src="${product.featured_images[0]}&width=480&height=684&crop=top&format=webp" alt="${product.title}" loading="lazy" class="h-full object-cover object-top rounded-t-md w-full loaded">`
                : ''
            }
          </div>
          </a>
        </div>
      `;

      row1Wrapper.appendChild(col);

      setTimeout(() => col.classList.add('visible'), index * 100);
    });

    // Swiper 1: Only row1
    new Swiper('.row1', {
      slidesPerView: 'auto',
      spaceBetween: 12,
      loop: true,
      a11y: false,
      speed: 20000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      freeMode: true,
      breakpoints: {
        768: {
          spaceBetween: 20,
        }
      }
    });
  }

  tabs.forEach((input) => {
    input.addEventListener('change', (e) => {
      const value = e.target.value;
      setActiveTab(input);

      let url =
        value === '/collections/all'
          ? `/collections/all/products.json?limit=30`
          : `${value}/products.json?limit=30`;

      fetch(url)
        .then((res) => (res.ok ? res.json() : Promise.reject('Collection not found')))
        .then((data) => {
          const products = (data.products || []).map((p) => ({
            title: p.title,
            handle: p.handle,
            featured_images: p.images.slice(0, 2).map((img) => img.src),
            url: `/products/${p.handle}`,
          }));
          renderSwiperProducts(products);
        })
        .catch((err) => console.error(err));
    });
  });

  const firstTab = tabs[0];
  if (firstTab) firstTab.click();
});


document.addEventListener('DOMContentLoaded', function () {
  var mySwiper = new Swiper('.testimonials-row', {
    spaceBetween: 24,
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    speed: 800,
    autoplay: {
      
      delay: 3000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.testimonials-row .swiper-button-next',
      prevEl: '.testimonials-row .swiper-button-prev',
    },
  });
});
document.addEventListener('DOMContentLoaded', function () {
  var mySwiper = new Swiper('.advanced-swiper', {
    spaceBetween: 24,
    slidesPerView: 2,
    loop: true,
    speed: 800,
    autoplay: false,
    navigation: {
      nextEl: '.advanced-swiper .swiper-button-next',
      prevEl: '.advanced-swiper .swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1.5,
        spaceBetween: 12,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 12,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
      1536: {
        slidesPerView: 5,
        spaceBetween: 24,
      },
    },
  });
});
